import React, { useEffect } from 'react'
import { Box, InputLabel, TextField } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { Autocomplete } from '@material-ui/lab'
import { Controller, useFormContext } from 'react-hook-form'

import { Select, LoadingFeedback } from 'components'

import useFetch from 'hooks/useFetch'

import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'

const ConsentForm = ({ setConsentForms, setFields }) => {
  const { control, watch, errors, setValue } = useFormContext()

  const { response, isLoading } = useFetch(
    service.dponet.consent.list,
    { noPagination: true },
    [],
  )
  const { SECONDARY_FIELD_ARRAY } = constants.consent
  const { getParsedFields } = helpers.consent
  const consentForms =
    response?.data?.consentForms?.filter(
      (form) => form.answersCollected?.total > 0,
    ) || []

  const consentFormId = watch('consentFormId')
  const fields = watch('fields')

  const { response: responseForm } = useFetch(
    service.dponet.consent.getStats,
    {
      consentFormId,
    },
    [consentFormId],
    !!consentFormId,
  )

  const formFields = responseForm?.data?.consentForms[0].components || []

  const parsedFields = getParsedFields(formFields)

  const fieldArray = [...parsedFields, ...SECONDARY_FIELD_ARRAY]

  useEffect(() => {
    setValue('fields', [])
  }, [consentFormId])

  useEffect(() => {
    setConsentForms([])
    if (responseForm?.data?.consentForms) {
      setConsentForms(responseForm?.data?.consentForms)
    }
    if (fields) {
      setFields(fields)
    }
  }, [responseForm, setConsentForms, fields, setFields])

  return (
    <Box display="flex" flexDirection="column" width="100%" paddingBottom={1}>
      <LoadingFeedback open={isLoading} />
      {!isLoading && (
        <Box display="flex" flexDirection="column" width="100%">
          <Controller
            control={control}
            name="consentFormId"
            as={
              <Select
                items={consentForms || []}
                fieldName="title"
                error={!!errors.consentFormId}
                helperText={errors?.consentFormId?.message}
                label="Selecione o formulário"
              />
            }
            mode="onChange"
          />
        </Box>
      )}
      {consentFormId && (
        <>
          <Box display="flex" flexDirection="column" width="100%" marginTop={3}>
            <InputLabel>
              Campo(s) do relatório a serem mostrados (opcional)
            </InputLabel>
            <Controller
              control={control}
              name="fields"
              mode="onChange"
              as={
                <Autocomplete
                  popupIcon={<ExpandMore />}
                  multiple
                  options={fieldArray}
                  filterSelectedOptions
                  getOptionSelected={(option, value) =>
                    option.id === value || option.id === value?.id
                  }
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                      return (
                        fieldArray.find((field) => field.id === option)?.name ||
                        option
                      )
                    }
                    return option.name || ''
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={!!errors.fields}
                      helperText={errors?.fields?.message}
                    />
                  )}
                />
              }
              onChange={([, data]) =>
                data.map((item) => (typeof item === 'string' ? item : item?.id))
              }
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default ConsentForm
